import { DataMap } from "./data_map";
import { TargetSet } from "./target_set";
import { attributeValueContainsToken } from "./selectors";
var Scope = /** @class */function () {
  function Scope(schema, identifier, element) {
    this.schema = schema;
    this.identifier = identifier;
    this.element = element;
    this.targets = new TargetSet(this);
    this.data = new DataMap(this);
  }
  Scope.prototype.findElement = function (selector) {
    return this.findAllElements(selector)[0];
  };
  Scope.prototype.findAllElements = function (selector) {
    var head = this.element.matches(selector) ? [this.element] : [];
    var tail = this.filterElements(Array.from(this.element.querySelectorAll(selector)));
    return head.concat(tail);
  };
  Scope.prototype.filterElements = function (elements) {
    var _this = this;
    return elements.filter(function (element) {
      return _this.containsElement(element);
    });
  };
  Scope.prototype.containsElement = function (element) {
    return element.closest(this.controllerSelector) === this.element;
  };
  Object.defineProperty(Scope.prototype, "controllerSelector", {
    get: function get() {
      return attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
    },
    enumerable: true,
    configurable: true
  });
  return Scope;
}();
export { Scope };